<template>
    <div class="home scroll-box">
            <discuss-tab
            :postCategoryList="postCategoryList"
            :options="options"
            @like="like"
            >
            </discuss-tab>
    </div>
</template>

<script>
    import HomeNav from "@/components/HomeNav.vue";
    import HomeBot from "@/components/HomeBot.vue";
    import DiscussTab from "@/components/DiscussTab.vue";
    import HomeSwiper from '@/components/HomeSwiper.vue'

    export default {
        name: "Home",
        components: {
            HomeNav,
            HomeBot,
            DiscussTab,
            HomeSwiper
        },
        data () {
            return {
                postCategoryList:[],
                dataList:[],
                options:{
                    curId:0,
                    cId:0,
                    indexId:0,
                    active: 0,
                    isCur:true,
                    isActive:false,
                }
            }
        },
        computed: {
            userInfo () {
                return this.$store.state.userInfo
            },
            swiperList() {
                return this.$store.state.swiperList
            }
        },
        methods:{
            async getCategories () {
               let {data} = await this.$http.get('/category/get');
               this.postCategoryList = data;
               this.$store.commit('setCategories', data);

            },
            like (item) {
                let t = this;
                item.is_liked = !item.is_liked;
                if(item.is_liked == true){
                    item.like_count++;
                } else {
                    item.like_count--;
                }
                let api = '/topic/like';
                t.$http.post(api,{
                        topic_id: item.id,
                        app_user_id: this.userInfo.app_user_id
                    })
                    .then((res) => {
                        if(res.data == true) {
                            // this.$toast("点赞成功！")
                        }
                    })
            }
        },
        mounted() {
           this.getCategories();
        }
    };
</script>

<style lang="stylus" scoped>
.home
    width 100%
.scroll-box
    position: fixed
    top:0 
    bottom 0
    z-index 1
    margin-left:0
    overflow-y: scroll
</style>